<template>
  <div class="home_wrap">
    <van-nav-bar
      title="Convidar"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <van-tabs
      v-model="active"
      animated
      sticky
      offset-top="1.2rem"
      lazy-render	
      class="vantTabs"
      @change="changeTabs"
    >
      <van-tab
        v-for="(item, index) in tabList"
        :key="item.title"
        :title="item.title"
      >
        <template v-if="item.components">
          <components
            :is="item.components"
            v-if="[0, 1, 9].includes(active)"
            @changeActive="changeActive"
          />
          <components
            :is="item.components"
            v-else
            :list="list"
            :active="active"
            @getList="getList"
          />
        </template>
        <template v-else>
          内容{{ index }}
        </template>
      </van-tab>
    </van-tabs>

    <div
      v-if="Object.keys(total).length && [2, 3, 6].includes(active)"
      class="total_box"
    >
      <div
        v-for="item in totalInfo"
        :key="item.key"
        class="total_item"
      >
        <div class="title">
          {{ item.title }}
        </div>
        <div class="key">
          {{ total[item.key] }}
        </div>
      </div>
    </div>
    <ft />
  </div>
</template>

<script>
import Vue from 'vue';
import { NavBar,  Tab, Tabs  } from 'vant';
import ft from "../../components/ft"
import Fetch from '../../utils/fetch';
import convite from './components/convite.vue';
import meus from './components/meus.vue';
import list from './components/list.vue';
import taxa from './components/taxa.vue';
import totalData from './totalInfo.json'

Vue.use(NavBar);
export default {
  name: "Agent",
  components: {
    ft,
    vanTab: Tab,
    vanTabs: Tabs,
    convite,
    meus,
    list,
    taxa
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      show_icon_type: 'about',
      data: {},
      active: 0,
      tabList: [
        {
          title: 'Link de Convite',
          components: 'convite'
        },
        {
          title: 'Meus Dados',
          components: 'meus'
        },
        {
          title: 'Todos os Dados',
          components: 'list'
        },
        {
          title: 'Desempenho',
          components: 'list'
        },
        {
          title: 'Comissão',
          components: 'list'
        },
        {
          title: 'Dados do Subordinado',
          components: 'list'
        },
        {
          title: 'Apostas dos Subordinados',
          components: 'list'
        },
        {
          title: 'Finanças dos Subordinados',
          components: 'list'
        },
        {
          title: 'Resgates dos subordinados',
          components: 'list'
        },
        {
          title: 'Taxa de Comissão',
          components: 'taxa'
        }
      ],
      totalInfo: [],
      total: {},
      list: []
    };
  },
  created() {
  },
  mounted() {
    this.start();
  },
  methods: {
    changeActive(active) {
      this.active = active
      this.changeTabs(active)
    },
    getList(params) {
      switch(this.active) {
        case 2:
          Fetch('/agent/allData', params).then(res => {
            this.list = res.data.page
            this.total = res.data.otherData
          })
          break;
        case 3:
          Fetch('/agent/performance', params).then(res => {
            this.list = res.data.page
            this.total = res.data.otherData
          })
          break;
        case 4:
          // Fetch('/agent/subActive', params).then(res => {
          //   this.list = res.data.page
          //   this.total = res.data.otherData
          // })
          break;
        case 5:
          Fetch('/agent/subActive', params).then(res => {
            this.list = res.data.records
            this.total = {}
          })
          break;
        case 6:
          Fetch('/agent/subBetReport', params).then(res => {
            this.list = res.data.records
            this.total = res.data.otherData
          })
          this.totalInfo = totalData.t3
          break;
        case 7:
          // this.getList()
          this.totalInfo = totalData.t4
          break;
      }
    },
    start() {
      // Fetch('/index/about').then((r) => {
      //   this.data = r.data;
      // });
    },
    onClickLeft() {
      this.$router.push("/");
    },
    changeTabs(e) {
      this.list = []
      this.totalInfo = {}
      switch(e) {
        case 2:
          this.getList()
          this.totalInfo = totalData.t1
          break;
        case 3:
          this.getList()
          this.totalInfo = totalData.t2
          break;
        case 5:
          this.getList()
          this.totalInfo = {}
          break;
        case 6:
          this.getList()
          this.totalInfo = totalData.t3
          break;
        case 7:
          this.getList()
          this.totalInfo = totalData.t4
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";
/deep/ .van-nav-bar--fixed {
  z-index: 2;
}
/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}
@media (min-width: @maxWidth) {
  :deep(.van-sticky) {
    position: static !important;
  }
}
.vantTabs {
  
  :deep(.van-sticky) {
    width: 100%;
    max-width: @maxWidth;
    // left: 50%;
    // transform: translateX(-50%);
  }
  :deep(.van-tabs__wrap) {
    height: 0.88rem;
    .van-tabs__nav {
      padding-left: 0;
      padding-right: 0;
      background-color: @secondary-color;
    }
    .van-tab {
      padding: 0 0.2rem;
      .van-tab__text {
        font-size: .32rem;
      }
      &.van-tab--active {
        span {
          color: @rechargeColor;
        }
      }
    }
    .van-tabs__line {
      background-color: @rechargeColor;
    }
  }
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  background-color: @activityColor;
  padding-top: 1.2rem;
}
.total_box{ 
  // position: fixed;
  // bottom: 60px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background-color: @secondary-color;
  padding: 5px 10px;
  border-top: 1px solid @bodercolor;
  .total_item {
    display: flex;
    .title {
      width: 80px;
      font-size: 10px;
      margin-bottom: 6px;
      color: @textcolorf;
      margin-right: 4px;
    }
    .key {
      color: @textcolor1;
    }
    &:nth-last-child(1) .key,
    &:nth-last-child(2) .key {
      color: @textcolor4;
    }
  }
  div {
    width: 50%;
  }
}

</style>
